// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dI","pgUseBox":"dI","use-card-wrap":"dJ","useCardWrap":"dJ","use-box-wrap":"dK","useBoxWrap":"dK"};